import { useEffect } from 'react';

import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';

import { usePatientSearch } from '../hooks/usePatientSearch';

import PatientPicker from './PatientPicker';

const AssignPatientModal = ({ open, setOpen, loading, onAssign }) => {
  const patientSearch = usePatientSearch({ enabled: open });
  const { setSelectedPatient, setFilters } = patientSearch;

  useEffect(() => {
    if (!open) return;

    setSelectedPatient(null);
    setFilters((prev) => ({ ...prev, searchTerm: '', search: '', page: 1 }));
  }, [open]);

  return (
    <Modal
      isOpen={open}
      handleClose={() => setOpen(false)}
      title="Assign to patient"
      customStyling={{ width: '540px' }}
      footer={
        <div className="flex w-full justify-between">
          <Button text="Cancel" variant="tertiary" onClick={() => setOpen(false)} />
          <Button
            isDisabled={!patientSearch.selectedPatient || loading}
            onClick={() => onAssign(patientSearch.selectedPatient)}
            isLoading={loading}
            text="Assign to patient"
          />
        </div>
      }>
      <div className="!mt-1 rounded-lg bg-white !p-2 shadow-sm">
        <PatientPicker {...patientSearch} />
      </div>
    </Modal>
  );
};

export default AssignPatientModal;
